import React from 'react';
import { Link } from 'react-router-dom';

const SUBJECT_COLORS = {
  'AI & Machine Learning': 'bg-blue-600',
  'Art & Design': 'bg-purple-600',
  Science: 'bg-green-600',
  History: 'bg-amber-600',
  Literature: 'bg-pink-600',
  'Computer Science': 'bg-cyan-600',
  'Job Training': 'bg-orange-600',
};

const ClockIcon = () => (
  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const BookIcon = () => (
  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
  </svg>
);

export default function CourseCard({ course }) {
  const isFree = course.price === 0;
  return (
    <div
      data-testid={`course-card-${course.course_id}`}
      className={`rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border ${
        isFree
          ? 'bg-gradient-to-br from-green-900/30 to-gray-900 border-green-500/50 hover:border-green-400 hover:shadow-green-500/20'
          : 'bg-gray-900 border-gray-800 hover:border-purple-500/50 hover:shadow-purple-500/20'
      }`}
    >
      <div className="flex items-center justify-between mb-4">
        <span
          className={`px-3 py-1 rounded-full text-xs font-semibold text-white ${
            SUBJECT_COLORS[course.subject] || 'bg-gray-600'
          }`}
        >
          {course.subject}
        </span>
        {isFree ? (
          <span className="px-3 py-1 bg-green-600 text-white rounded-full text-xs font-bold animate-pulse">FREE</span>
        ) : (
          <span className="text-sm font-medium text-gray-400">{course.level}</span>
        )}
      </div>

      <h3 className="text-xl font-bold mb-2 line-clamp-2 min-h-[3.5rem] text-white">{course.title}</h3>
      <p className="text-sm text-gray-400 mb-3">By {course.instructor}</p>
      <p className="text-sm text-gray-300 mb-4 line-clamp-3">{course.description}</p>

      <div className="flex items-center justify-between text-sm mb-4">
        <span className="flex items-center gap-1 text-gray-400">
          <ClockIcon />
          {course.duration}
        </span>
        <span className="flex items-center gap-1 text-gray-400">
          <BookIcon />
          {course.modules?.length || 0} modules
        </span>
      </div>

      <div className="flex items-center justify-between pt-4 border-t border-gray-800">
        <span className="text-2xl font-bold text-purple-400">
          {isFree ? 'FREE' : `$${course.price}`}
        </span>
        <Link
          to={`/course/${course.course_id}`}
          data-testid={`view-course-${course.course_id}`}
          className="btn-primary text-sm px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg inline-block"
        >
          View Details
        </Link>
      </div>
    </div>
  );
}
